module.exports = __webpack_public_path__ + "static/media/trash-biohazard-open.5ffebfd2.svg";